<div class="dialog -m-6 flex flex-col">
  <div class="flex h-16 flex-0 items-center justify-between px-4">
    <div class="text-lg font-medium">Complete Your Profile</div>
    <button mat-icon-button (click)="close()" [disabled]="loading > 0" [tabIndex]="-1">
      <mat-icon class="text-current" fontIcon="close"></mat-icon>
    </button>
  </div>
  <mat-divider></mat-divider>
  <div class="overflow-y-auto p-4" style="max-height: 70vh">
    <div class="mb-4 flex flex-col items-center text-center">
      <img class="mb-2 h-24 w-24 shrink-0 rounded-full object-cover shadow" [src]="user?.profile_image_url | avatar: user?.full_name" [alt]="user?.full_name" />
      <p class="m-0 text-base font-semibold">{{ user?.full_name }}</p>
      <p class="text-secondary m-0 text-sm">{{ user?.role?.title }}</p>
    </div>

    <p class="text-secondary mb-4 text-sm">Your profile is incomplete. A complete profile helps your team recognize and reach you.</p>

    <div class="mb-1.5 flex items-center justify-between md:min-w-[480px]">
      <span class="text-sm font-medium">Profile Completion</span>
      <span class="text-base font-bold text-primary">{{ completionPercent }}%</span>
    </div>
    <div class="h-4 w-full overflow-hidden rounded-full bg-gray-100 shadow-inner">
      <div class="h-full rounded-full bg-green-500 transition-all duration-700 ease-out" [style.width.%]="displayPercent"></div>
    </div>

    @if (missingFields.length) {
      <div class="mt-4 text-sm">
        <span class="text-secondary me-1">Missing:</span>
        <span class="font-medium">{{ missingFields.join(', ') }}</span>
      </div>
    }
  </div>
  <mat-divider></mat-divider>
  <div class="flex items-center justify-end gap-2 px-4 py-3">
    <button mat-stroked-button type="button" color="primary" [disabled]="loading > 0" (click)="close()">Later</button>
    <button mat-stroked-button type="button" color="primary" [disabled]="loading > 0" (click)="remindLater()">Remind Me in 30 Days</button>
    <button mat-flat-button color="primary" type="button" [disabled]="loading > 0" (click)="goToEditProfile()">
      <mat-icon class="icon-size-5" fontIcon="edit"></mat-icon>
      <span class="ms-2">Complete Profile</span>
    </button>
  </div>
</div>
